module.exports = __webpack_public_path__ + "static/small-desarrollo-mobile.d3b8e138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/small-desarrollo-mobile.jpg
// module id = 673
// module chunks = 35783957827783